import { useEffect, useState } from "react";
import ButtonControl from "../../../../components/controls/ButtonControl";
import { asyncForEach } from "../../../contentLibrary/utils/jsUtil";
import "./../../payout.scss";
import "./../payout/styles/payoutRecipients.scss";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../../components/Loading";
import AddTeachersMgmt from "./AddTeachersMgmt";
import TeacherTableRows from "./TeacherTableRows";
import TeacherTableHeader from "./TeacherTableHeader";

export const calcCompassEquivalent = {
  "5.0": 4.0,
  5: 4.0,
  4.5: 3.8,
  "4.0": 3.6,
  4: 3.6,
  3.5: 3.4,
  "3.0": 2.8,
  3: 2.8,
  2.5: 2.4,
  "2.0": 1.8,
  2: 1.8,
  1.5: 1.4,
  "1.0": 1.0,
  1: 1.0,
};
const PayoutRecipients = ({
  data,
  payoutInfo,
  appUserMgr,
  payoutMgr,
  payoutTeacherConfig,
  hideCompassEq,
  onNext,
  onPrevious,
  onExport,
  handleRefresh,
}) => {
  const [recipeients, setRecipients] = useState();
  const [isAdminRecipients, setIsAdminRecipients] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showPaymentSettings, setShowPaymentSettings] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState();
  const [selectedDistrict, setSelectedDistrict] = useState();
  const [selectedSchool, setSelectedSchool] = useState();
  const [updatedRowIndices, setUpdatedRowIndices] = useState([]);
  const [selectedPayoutRole, setSelectedPayoutRole] = useState("");
  const [selectedAchievementType, setSelectedAchievementType] = useState("");
  const [valueToUpdate, setValueToUpdate] = useState(null);
  const [indicatorMessage, setIndicatorMessage] = useState(false);
  const [columns, setColumns] = useState([
    {
      header: "Eligible Payee",
      dataProp: "EligiblePayee",
      width: "16.33%",
      canSort: true,
      boldText: true,
      leftSide: true,
    },
    {
      header: "Exclude",
      dataProp: "IsExclude",
      width: "5.33%",
      isBool: true,
      canSort: true,
    },
    {
      header: "Hard to Fill",
      dataProp: "IsHardToFill",
      width: "4.33%",
      isBool: true,
      canSort: true,
    },
    {
      header: "Payout Role",
      dataProp: "PayoutRoleId",
      width: "11.33%",
      leftAlign: true,
      canSort: true,
    },
    {
      header: "SKR Score",
      dataProp: "SKRScore",
      width: "6.33%",
      centerInput: true,
      canSort: true,
    },
    {
      header: "Compass Equiv.",
      dataProp: "CompassEquiv",
      width: "7.33%",
      centerInput: true,
      canSort: true,
    },
    {
      header: "Survey Score",
      dataProp: "SurveyScore",
      width: "6.33%",
      centerInput: true,
      canSort: true,
    },
    {
      header: "Apply Value-Added Score",
      dataProp: "IsApplyValueAddedScore",
      width: "7.33%",
      isBool: true,
      canSort: false,
    },
    {
      header: "Achievement Type",
      dataProp: "PayoutAchievementTypeId",
      width: "12.33%",
      canSort: true,
    },
    {
      header: "Value-Added Score",
      dataProp: "ValueAddedScore",
      width: "8.33%",
      centerInput: true,
      canSort: false,
    },
    {
      header: "Apply % Payout",
      dataProp: "PayoutPct",
      width: "7.33%",
      centerItems: true,
      canSort: true,
      centerInput: true,
    },
    {
      header: "Comment",
      dataProp: "Comment",
      width: "9.33%",
      canSort: true,
      lastCol: true,
    },
  ]);

  useEffect(() => {
    let newRows = [];
    if (data) {
      if (hideCompassEq)
        setColumns(columns.filter((x) => x.dataProp !== "CompassEquiv"));

      asyncForEach(data, (u) => {
        const flooredSKRScore = Math.floor(u.SKRScore * 2 + 0.49) / 2;
        newRows.push({
          ...u,
          IsExclude: !u.IsActive,
          PayoutConfigurationId:
            u.PayoutConfigurationId ?? payoutTeacherConfig.Id,
          isEdited: !u.PayoutConfigurationId,
        });
      }).then(() => {
        setRows(newRows);
        setLoading(false);
      });
    }
  }, [data]);

  const handleOnNext = async () => {
    setSaving(true);
    await onNext(rows);
    setSaving(false);
  };

  const handleOnChange = (rowId, selectedValue, dataProp) => {
    const updatedRows = rows.map((row) => {
      if (row.Id === rowId) {
        if (dataProp === "ValueAddedScore") {
          row.StudentAchievementScore = selectedValue;
        }
        if (dataProp === "IsApplyValueAddedScore") {
          if (!selectedValue) {
            row.PayoutAchievementTypeId = null;
            row.StudentAchievementScore = null;
            row.ValueAddedScore = null;
          }
        }
        if (dataProp === "SKRScore") {
          row.CompassEquiv =
            calcCompassEquivalent[Math.floor(selectedValue * 2 + 0.49) / 2];
        }
        return {
          ...row,
          [dataProp]: selectedValue,
          isEdited: true,
        };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const handleOnCheckBox = (rowId, dataProp) => {
    if (dataProp === "IsExclude") dataProp = "IsActive";
    const updatedRows = rows.map((row) => {
      if (row.Id === rowId) {
        return {
          ...row,
          [dataProp]: !row[dataProp],
          isEdited: true,
        };
      }
      return row;
    });
    setRows(updatedRows);
  };

  return (
    <>
      {!loading ? (
        <>
          <div className="payout-teacher-table">
            <div className="payout-recipients-title">
              <h2>Edit Teacher Payout</h2>
              <h5>
                {payoutInfo?.Client?.Name} &gt; {payoutInfo?.District?.Name}{" "}
                &gt; {payoutInfo?.School?.Name}
              </h5>
            </div>
            <div className="recipientTable">
              <div className="control-box-wrapper control-box-padding">
                <div className="control-box-list">
                  <div className="wrapper">
                    <TeacherTableHeader columns={columns} />
                    <TeacherTableRows
                      data={data.filter((x) => x.IsManual === false)}
                      rows={rows}
                      columns={columns}
                      isComplete={
                        payoutTeacherConfig?.PayoutConfiguration?.IsCompleted
                      }
                      payoutAchievementTypes={
                        payoutTeacherConfig.PayoutAchievementTypes
                      }
                      handleOnChange={handleOnChange}
                      appUserMgr={appUserMgr}
                      handleOnCheckBox={handleOnCheckBox}
                    />
                  </div>
                  {error && <div className="error-msg">*{errorMessage}</div>}
                  <AddTeachersMgmt
                    data={data}
                    saving={saving}
                    payoutInfo={payoutInfo}
                    isCompleted={
                      payoutTeacherConfig?.PayoutConfiguration?.IsCompleted
                    }
                    payoutMgr={payoutMgr}
                    handleRefresh={handleRefresh}
                  />
                  {data.some((x) => x.IsManual === true) && (
                    <div className="wrapper">
                      <TeacherTableHeader columns={columns} />
                      <TeacherTableRows
                        data={data.filter((x) => x.IsManual === true)}
                        rows={rows}
                        columns={columns}
                        isComplete={
                          payoutTeacherConfig?.PayoutConfiguration?.IsCompleted
                        }
                        payoutAchievementTypes={
                          payoutTeacherConfig.PayoutAchievementTypes
                        }
                        handleOnChange={handleOnChange}
                        appUserMgr={appUserMgr}
                        handleOnCheckBox={handleOnCheckBox}
                      />
                    </div>
                  )}
                  <div className="button-row">
                    <div className="min-obs-indicator">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        className="obs-icon"
                      />{" "}
                      Indicates Minimum Observations Not Met
                    </div>
                    <div className="button-wrapper">
                      <div className="btn-wrapper-left screen-footer__btn">
                        <ButtonControl
                          loading={saving}
                          type={"cancel"}
                          onClick={async () => {
                            onExport(payoutInfo);
                          }}
                        >
                          Export Data
                        </ButtonControl>
                      </div>
                      <div className="btn-wrapper-left screen-footer__btn">
                        <ButtonControl
                          disabled={saving}
                          type={"cancel"}
                          onClick={onPrevious}
                        >
                          Cancel
                        </ButtonControl>
                      </div>
                      <div className="btn-wrapper-left screen-footer__btn">
                        <ButtonControl
                          loading={saving}
                          type={"okay"}
                          onClick={handleOnNext}
                        >
                          {appUserMgr.canWrite(
                            "ConfigurePayoutTeacherConfiguration"
                          )
                            ? "Save & Continue"
                            : "Save"}
                        </ButtonControl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="loading-container">
            <Loading type="default" size="5rem" />
            <div className="loading-font">Loading...</div>
          </div>
        </>
      )}
    </>
  );
};

export default PayoutRecipients;
